import { render, staticRenderFns } from "./DocVerifyPaymentCallback.vue?vue&type=template&id=9d93d280&scoped=true"
import script from "./DocVerifyPaymentCallback.vue?vue&type=script&lang=js"
export * from "./DocVerifyPaymentCallback.vue?vue&type=script&lang=js"
import style0 from "./DocVerifyPaymentCallback.vue?vue&type=style&index=0&id=9d93d280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d93d280",
  null
  
)

export default component.exports